/* ----------------------------------------------------------------------------
js entry point
---------------------------------------------------------------------------- */
import { setupViews } from "./views/setupViews.js";

setupViews();